import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, finalize } from "rxjs";
import { NavigationStart, Route, Router } from "@angular/router";

@Injectable()
export class BackButtonNavigatorInterceptor implements HttpInterceptor {
    constructor(private router: Router) {
        this.deshabilitaRetroceso();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        this.router.events.subscribe((event: NavigationStart) => {
            if (event.navigationTrigger === 'popstate') {
                this.deshabilitaRetroceso();
                this.router.navigate([this.router.url]);
                
                
            }
        });        
        return next.handle(req);
    }
    deshabilitaRetroceso(){
		//window.location.hash="no-back-button";
		//window.location.hash="Again-No-back-button" //chrome
		window.onhashchange = function(){
            window.location.hash="Again-No-back-button"//"no-back-button";
        }
	}
}